import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

const appId = process.env.REACT_APP_LOGROCKET_APP_ID;
const allowedHeaderNames = [
  "accept",
  "content-length",
  "content-type",
  "x-oj-client-id",
];

type LogRocketNetworkPayload = {
  body?: unknown;
  headers?: Record<string, unknown>;
};

const sanitizeHeaders = (headers?: Record<string, unknown>) => {
  if (!headers) {
    return headers;
  }

  return Object.keys(headers).reduce<Record<string, unknown>>(
    (sanitizedHeaders, headerName) => {
      const normalizedHeaderName = headerName.toLowerCase();
      const headerValue = headers[headerName];
      sanitizedHeaders[headerName] = allowedHeaderNames.includes(
        normalizedHeaderName
      )
        ? headerValue
        : `[${String(headerValue).length} bytes]`;

      return sanitizedHeaders;
    },
    {}
  );
};

const sanitizeNetworkRequest = <T extends LogRocketNetworkPayload>(
  payload: T
): T =>
  ({
    ...payload,
    body: "[redacted]",
    headers: sanitizeHeaders(payload.headers),
  }) as T;

const sanitizeNetworkResponse = <T extends LogRocketNetworkPayload>(
  payload: T
): T =>
  ({
    ...payload,
    body: "[redacted]",
    headers: sanitizeHeaders(payload.headers),
  }) as T;

if (appId) {
  LogRocket.init(appId, {
    mergeIframes: true,
    dom: {
      textSanitizer: true,
      inputSanitizer: true,
    },
    network: {
      requestSanitizer: sanitizeNetworkRequest,
      responseSanitizer: sanitizeNetworkResponse,
    },
  });
  setupLogRocketReact();
  LogRocket.track("logrocket_bootstrap", {});
}
